import { CheckIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { Button } from '@library/components/buttons';
import { MessageBanner } from '@library/components/banners/MessageBanner';
import { cn } from '@library/component-utils/cn';
import { copyTextToClipboard } from '@bo-utils/common';
import { useState } from 'react';

export interface CopyToClipboardButtonProps {
  bannerMessage?: string;
  btnClassName?: string;
  iconClassName?: string;
  iconSize?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  textCopied: string;
}

export const CopyToClipboardButton = ({
  bannerMessage = undefined,
  btnClassName = '',
  iconClassName = '',
  iconSize = 4,
  textCopied
}: CopyToClipboardButtonProps) => {
  const [isCopyClicked, setisCopyClicked] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  const copyText = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setisCopyClicked(true);
    if (bannerMessage) {
      setShowBanner(true);
    }

    await copyTextToClipboard(event, textCopied);

    setisCopyClicked(false);
    if (bannerMessage) {
      setShowBanner(false);
    }
  };

  return (
    <>
      <Button
        onClick={copyText}
        className={cn('flex items-center justify-center', btnClassName)}
      >
        {isCopyClicked ? (
          <CheckIcon
            className={cn(
              `text-status-success hover:text-status-success size-${iconSize}`
            )}
          />
        ) : (
          <DocumentDuplicateIcon
            className={cn(`size-${iconSize}`, iconClassName)}
          />
        )}
      </Button>
      {showBanner && (
        <MessageBanner code="SUCCESS" message={bannerMessage ?? ''} />
      )}
    </>
  );
};
